<template>
  <div class="individuals-interesting-facts" id="factsElement">
    <h3 :style="{ color: color }">{{title}}</h3>
    <div class="individuals-interesting-facts-container">
      <div class="interesting-fact" v-for="(f, i) in facts" :key="`fact-${i}`">
        <img :src="f.img" alt="Background">
        <p class="text-light">{{f.text}}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["title", "color", "facts"]
};
</script>

<style lang="scss" scoped>
.individuals-interesting-facts {
  @extend %flex-center;
  background-color: $bgColor1;
  flex-direction: column;
  padding: 40px $sidesPadding;
  margin: 40px 0;
  .individuals-interesting-facts-container {
    padding-top: 40px;
    @extend %flex-center;
    flex-wrap: wrap;
    justify-content: flex-start;
    width: 100%;
    .interesting-fact {
      @extend %flex-center;
      justify-content: flex-start;
      position: relative;
      width: 33.33%;
      img {
        width: 60%;
      }
      p {
        font-size: 13px;
        width: 60%;
        right: 0;
        top: 50%;
        @include transform(translateY(-50%));
        position: absolute;
      }
    }
  }
}
@media screen and (max-width: 1600px) {
  .individuals-interesting-facts {
    padding: 40px $sidesPadding1600;
    .individuals-interesting-facts-container {
      .interesting-fact {
        img {
          width: 65%;
        }
        p {
          font-size: 12px;
          line-height: 16px;
        }
      }
    }
  }
}
@media screen and (max-width: 1280px) {
  .individuals-interesting-facts {
    padding: 40px $sidesPadding1280;
    .individuals-interesting-facts-container {
      .interesting-fact {
        width: 50%;
        img {
          width: 65%;
        }
        p {
          font-size: 12px;
          line-height: 16px;
        }
      }
    }
  }
}
@media screen and (max-width: 1000px) {
  .individuals-interesting-facts {
    .individuals-interesting-facts-container {
      .interesting-fact {
        width: 50%;
        img {
          width: 90%;
          opacity: 0.8;
        }
        p {
          font-size: 11px;
          line-height: 13px;
        }
      }
    }
  }
}
@media screen and (max-width: 600px) {
  .individuals-interesting-facts {
    .individuals-interesting-facts-container {
      .interesting-fact {
        width: 100%;
        img {
          width: 90%;
        }
        p {
          font-size: 10px;
          line-height: 12px;
        }
      }
    }
  }
}
</style>

